import React, { ErrorInfo } from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export class ErrorBoundary extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    // Catch errors in any components below and re-render with error message
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // You can also log error messages to an error reporting service here
  }

  render() {
    if (this.state.errorInfo) {
      // Error path
      return (
        <Container fluid className={'text-center mt-5 pt-5'}>
          <h1>Something went wrong</h1>
          <p>An error has occurred during the rendering, please see the error message below for more details.</p>
          <Row className="text-left">
            <Col md={{ span: 4, offset: 4 }}>
              <details
                style={{
                  whiteSpace: 'pre-wrap',
                  backgroundColor: '#f8f9fa',
                  padding: '1rem',
                  borderRadius: '0.25rem',
                  border: '1px solid #ced4da',
                }}
              >
                <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>Error Details</summary>
                {this.state.error && this.state.error.toString()}
                <br />
                {this.state.errorInfo.componentStack}
              </details>
            </Col>
          </Row>
        </Container>
      );
    }
    // Normally, just render children
    return this.props.children;
  }
}
